import {
  Component,
  input,
  Input,
  OnChanges,
  OnInit,
  output,
  SimpleChanges,
} from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {
  AwFormFieldComponent,
  AwFormFieldLabelComponent,
  AwFormMessageComponent,
} from '@assetworks-llc/aw-component-lib';

@Component({
  selector: 'app-aw-text-form',
  imports: [
    AwFormFieldComponent,
    AwFormFieldLabelComponent,
    AwFormMessageComponent,
    ReactiveFormsModule,
  ],
  templateUrl: './aw-text-form.component.html',
  styleUrl: './aw-text-form.component.scss',
  standalone: true,
})
export class AwTextFormComponent implements OnInit, OnChanges {
  disable = input(false);
  readOnly = input(false);
  required = input(false);
  title = input('');
  value = input<string | null>('');
  placeholder = input('Enter Value');

  textEntry = output<string | null>();

  userForm!: FormGroup;

  ngOnInit(): void {
    this.userForm = new FormGroup({
      userInput: new FormControl(
        { value: this.value(), disabled: this.disable() },
        [Validators.required, Validators.minLength(1)]
      ),
    });
    this.userForm.controls['userInput'].valueChanges.subscribe((text) => {
      this.textEntry.emit(text ?? '');
    });
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['value'] && !changes['value'].firstChange && this.userForm) {
      this.userForm.controls['userInput'].setValue(
        changes['value'].currentValue,
        { emitEvent: false }
      );
    }

    if (
      changes['disable'] &&
      !changes['disable'].firstChange &&
      this.userForm
    ) {
      const ctrl = this.userForm.controls['userInput'];
      changes['disable'].currentValue
        ? ctrl.disable({ emitEvent: false })
        : ctrl.enable({ emitEvent: false });
    }
  }
}
